(self.webpackChunk_pwrc_docs=self.webpackChunk_pwrc_docs||[]).push([[829],{829:(d,t,n)=>{"use strict";n.r(t),n.d(t,{default:()=>c});var u=n(378),_=n.n(u);function E(){return u.createElement("h1",null,"404: Not found")}const c=E}}]);
